<template>
  <!-- eslint-disable -->
  <v-dialog v-model="dialog" persistent max-width="500px" content-class="user-edit-dialog">
    <v-toolbar style="background-color: #f5f5f5; height: unset;">
      <v-toolbar-title>
        <v-avatar large class="red">
          <span v-if="editMode" class="white--text headline">
            {{ editModel.UserName ? editModel.UserName.match(/\b(\w)/g)[0].toUpperCase() : ""}}
          </span>
          <span v-else class="white--text headline">
            {{ selectedUser.UserName ? selectedUser.UserName.match(/\b(\w)/g)[0].toUpperCase() : ""}}
          </span>
        </v-avatar>
      </v-toolbar-title>
      <v-toolbar-title>{{selectedUser.FirstName}} {{selectedUser.LastName}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-show="!editMode">
        <v-btn text class="edit-user-dialog-btn" icon @click="edit(selectedUser)">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn class="closeDialogue" text icon @click.native="reset()">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card v-show="editMode">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field class="user-first-name-field" label="First Name" single-line v-model="editModel.FirstName" prepend-icon="account_box"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field class="user-last-name-field" label="Last Name" single-line v-model="editModel.LastName"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-email-field" label="Email" v-model="editModel.Email" single-line :rules="[rulesParcelshieldUserEmail, rulesRequired]" required prepend-icon="mail"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-username-field" ref="username" label="User Name" v-model="editModel.UserName" :error-messages="userNameError" validate-on-blur required :rules="[rulesRequired, rulesWhiteSpace, v => validateUserName(v) || 'UserName must be unique']" single-line @click:append="() => (setUsernameAsEmail())" append-icon="mail" prepend-icon="assignment_ind"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-phone-field" label="Phone" single-line v-model="editModel.PhoneNumber" :rules="[rulesPhone]" prepend-icon="phone"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-clients-select" content-class="user-clients-list" :items="clients" v-model="editModel.ClientId" prepend-icon="business" item-text="Name" item-value="Id" label="Client" single-line :rules="[rulesRequired]" required :append-icon="editModel.ClientId == null  ? '' : 'clear'" @click:append="() => (editModel.ClientId = null)"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-questions-select" content-class="user-questions-list" :items="questions" v-model="editModel.PasswordQuestion" prepend-icon="lock" label="Password Question" single-line required :rules="[rulesRequired]" :append-icon="editModel.TimeZone == null  ? '' : 'clear'" @click:append="() => (editModel.PasswordQuestion = null)"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-password-field" label="Password Answer" single-line v-model="editModel.PasswordAnswer" prepend-icon="lock_open" required :rules="[rulesRequired]"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-timezone-select" content-class="user-timezone-list" :items="timeZones" v-model="editModel.TimeZone" prepend-icon="query_builder" label="Time Zone" single-line :append-icon="editModel.TimeZone == null  ? '' : 'clear'" @click:append="() => (editModel.TimeZone = null)"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-checkbox label="Reset Password" v-model="resetPassword" />
              </v-flex>
              <v-flex xs6 v-show="resetPassword">
                <v-radio-group v-model="editModel.SendEmail">
                  <v-radio label="No Email" value=""></v-radio>
                  <v-radio label="Send Welcome Email" value="WELCOME"></v-radio>
                  <v-radio label="Send Reset Email" value="RESET"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-show="resetPassword">
                <v-text-field label="Password" single-line v-model="editModel.Password" prepend-icon="lock" :append-icon="passVisible ? 'visibility' : 'visibility_off'" @click:append="() => (passVisible = !passVisible)" :type="passVisible ? 'text' : 'password'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card v-show="!editMode">
      <v-card-title>
        <h5 class="title">User Details</h5>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>assignment_ind</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.UserName}}
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>mail</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.Email}}
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>contact_mail</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              <a mailto="">{{selectedUser.Email}}</a>
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>contact_phone</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PhoneNumber}}
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>business</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{getClientName(selectedUser.ClientId)}}
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>lock</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PasswordQuestion}}
            </v-flex>
            <v-flex xs1 offset-xs2 class="text-xs-left">
              <v-icon>lock_open</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PasswordAnswer}}
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title style="display: block;">
        <h5 class="title" xs12>Role Assignment</h5>
        <h6 class="subheader">Define a user's roles</h6>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs8 offset-xs2 class="text-xs-left">
              <b>Role(s)</b>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="role in selectedUser.UserRoles" :key="role.Id" v-show="!editMode">
            <v-flex class="text-xs-left" xs8 offset-xs2 v-if="role.Selected">
              {{role.Name}}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="role in editModel.UserRoles" :key="role.Id" v-show="editMode">
            <v-flex xs10 offset-xs1>
              <v-checkbox class="role-toggle-cb" v-model="role.Selected" :label="role.Name" height="5"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title style="display: block;">      
        <v-layout row wrap>
          <v-flex xs6>
            <h5 class="title" xs12>User Claims</h5>
            <h6 class="subheader">Define a user's claims</h6>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn class="add-claim-btn" text icon @click.native="addClaim()" v-show="editMode">
              <v-icon >add_circle_outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs8 offset-xs2 class="text-xs-left">
              <b>Claims(s)</b>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="claim in selectedUser.UserClaims" v-show="!editMode && !claim.Delete" :key="claim.ClaimId">
            <v-flex class="text-xs-left" xs5 offset-xs2>
              {{claim.ClaimType}}
            </v-flex>
            <v-flex xs5 class="text-xs-left" >
              {{claim.ClaimValue}}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="claim in editModel.UserClaims" class="editable-claims" v-show="editMode && !claim.Delete" :key="claim.ClaimId + claim.ClaimValue +'edit'" v-on:mouseenter="hoverClaim(claim, true)" v-on:mouseleave="hoverClaim(claim, false)">
            <v-layout row wrap v-show="!claim.edit" class="claim-layout" @click="editClaim(claim)" v-if="!claim.Delete">
              <v-flex class="text-xs-left" xs1 offset-xs1 >
                <v-list-item-action v-if="editMode">
                  <div v-if="claim.hover">
                    <v-tooltip bottom>
                      <v-icon slot="activator" small>mode_edit</v-icon>
                      <span>Edit</span>
                    </v-tooltip>
                  </div>
                </v-list-item-action>
              </v-flex>
              <v-flex class="text-xs-left claim-type" xs4>{{claim.ClaimType}}</v-flex>
              <v-flex xs5 class="text-xs-left claim-value" >{{claim.ClaimValue}}</v-flex>
            </v-layout>
          </v-layout>
          <v-layout row wrap v-if="showClaimForm" class="claim-form-layout" style="background: #f5f5f5; margin: 15px 25px; padding: 0 15px;">
            <v-flex xs6 class="text-xs-left" style="padding-top: 20px;">
              <h4><span v-if="addNewClaim">Add Claim</span><span v-else>Edit Claim</span></h4>
            </v-flex>
            <v-flex  xs6>
              <v-btn text icon @click="deleteClaim()" class="delete-claim-btn" v-if="!addNewClaim">
                <v-icon small>delete</v-icon>
              </v-btn>
              <v-btn text icon @click="confirmClaim()" class="claim-confirm-btn" :disabled="!validClaim">
                <v-icon small>check</v-icon>
              </v-btn>
              <v-btn text icon @click.native="resetClaim()" class="reset-claim-button">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex  xs12>
              <v-form v-model="validClaim" class="claim-form" ref="claimForm" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field label="Claim Type" class="claim-type-field" :rules=[rulesRequired] single-line v-model="claimTypeEdit"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field label="Claim Value" class="claim-value-field" :rules=[rulesRequired] single-line v-model="claimValueEdit"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions v-show="editMode">
        <v-btn text class="cancel-edit-btn" color="primary" @click="cancelEdit()">Cancel</v-btn>
        <v-btn text color="primary" class="save-user-btn" :disabled="!valid" @click="save()">Save {{editModel.SendResetEmail ? " and Send" : ""}}</v-btn>
        <div class="error--text" v-if="!valid">Form Invalid Correct Errors Above</div>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- eslint-enable -->
</template>
<script>
import { PARCEL_SHIELD_USERS_NAMESPACE } from "./store/parcelShieldUserStore";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";
import UserDialogMixin from "@/mixins/UserDialogMixin.js";
export default {
  name: "ParcelShieldUserDialog",
  mixins: [RulesMixin, UserDialogMixin],
  data() {
    return {
      addNewClaim: false,
      claimTypeEdit: "",
      claimValueEdit: "",
      editClaimModel: {},
      showClaimForm: false,
      validClaim: false
    };
  },
  computed: {
    ...mapGetters(PARCEL_SHIELD_USERS_NAMESPACE, [
      "selectedUser",
      "users",
      "loading",
      "roles",
      "clients"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.USER_DIALOG_MIXIN_NAMESPACE = PARCEL_SHIELD_USERS_NAMESPACE;
    this.$parent.$on("userEdit", this.show);
  },
  methods: {
    cancelEdit() {
      if (this.editModel.Id) {
        this.editMode = false;
        this.showAddClaim = false;
        this.resetClaim();
      } else {
        this.reset();
      }
    },
    reset() {
      this.$refs.form.reset();
      this.editModel = {};
      this.editMode = false;
      this.dialog = false;
      this.resetClaim();
    },
    getClientName(clientId) {
      var client = this.clients.find(x => {
        return x.Id === clientId;
      });
      if (client) return client.Name;
      return "No Client Set";
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(
            `${PARCEL_SHIELD_USERS_NAMESPACE}/saveUser`,
            _.cloneDeep(this.editModel)
          )
          .then(res => {
            this.reset();
          });
      }
    },
    edit(user) {
      this.editModel = _.cloneDeep(user);
      this.editModel.UserRoles = _.cloneDeep(this.roles);
      if (user.UserRoles) {
        user.UserRoles.forEach(userRole => {
          this.editModel.UserRoles.forEach(editRole => {
            if (userRole.RoleId === editRole.RoleId) {
              editRole.Selected = userRole.Selected;
            }
          });
        });
      }
      if (!this.editModel.UserClaims) {
        this.editModel.UserClaims = [];
      }
      this.editMode = true;
      setTimeout(this.$refs.form.validate, 100);
    },
    show(mode) {
      this.dialog = true;
      if (mode === 1) {
        this.editModel.UserRoles = this.roles;
        this.editModel.UserClaims = [];
        this.editMode = true;
      }
    },
    hoverClaim(claim, hover) {
      claim.hover = hover;
      this.$forceUpdate();
    },
    editClaim(claim) {
      claim.edit = true;
      this.editClaimModel = claim;
      this.claimTypeEdit = this.editClaimModel.ClaimType;
      this.claimValueEdit = this.editClaimModel.ClaimValue;
      this.showClaimForm = true;
      this.$forceUpdate();
    },
    deleteClaim() {
      this.editClaimModel.Delete = true;
      this.resetClaim();
      this.$forceUpdate();
    },
    confirmClaim() {
      if (this.$refs.claimForm.validate()) {
        if (this.addNewClaim) {
          this.editModel.UserClaims.push({
            ClaimType: this.claimTypeEdit,
            ClaimValue: this.claimValueEdit
          });
        } else {
          this.editClaimModel.ClaimType = this.claimTypeEdit;
          this.editClaimModel.ClaimValue = this.claimValueEdit;
          this.editClaimModel.edit = false;
        }
        this.resetClaim();
        this.$forceUpdate();
      }
    },
    resetClaim() {
      this.showClaimForm = false;
      this.addNewClaim = false;
      this.editClaimModel = {};
      this.$forceUpdate();
    },
    addClaim() {
      this.claimTypeEdit = "";
      this.claimValueEdit = "";
      this.addNewClaim = true;
      this.showClaimForm = true;
    }
  }
};
</script>
